define(function (require) {


	//utilities
	const view_manager = require('civicsUtils/view_manager');

	const CN = require('civicsUtils/constants');
	//site types
	const address = 'address';
	const parcel = 'parcel';
	const asset = 'asset';
	const property = 'property';
	//methods
	const autocomplete = 'autocomplete';
	const mapclick = 'mapclick';
	const geolocation = 'geolocation';
	
	return {
		autocompleteCallback: function (delegateResponse, selectedItem, extentSize) {
			//any excess data from the autocomplete data is stored in the model attribute. We're going to move it to the main object.
			var mdl = selectedItem.model ? selectedItem.model : {};
			delete selectedItem.model;
			//autocomplete adds a label based on whatever it's told to display. we don't want to overwrite that,
			//just in case the model has a label attribute we handle that here.
			if (mdl.label) {
				mdl.label_other = mdl.label
				delete mdl.label
			}
			var response = $.extend({_method:autocomplete}, selectedItem, mdl, delegateResponse);
			
			//this.setFieldToValue('');
			this.clearAutocomplete();
			this.resetErrorMessages();
			this.closeLocationPicker();

			//we don't support esri in this release. We will need to add support to use this view for CRM, however.
				//esri findaddresscandidate returns the spatial in the delegate as the location.
				// if (response.location) {
				// 	this.getIPSLocationForCoordinates(response.location, extentSize);
				// } else {
			//lucene just returns us IDs and we will need to go fetch the proper parcel/address info ourselves
			//this.locationObject.isExact = true;
			if(this.canAddSite()){
				this.getIPSDataForLocation(response);
			} else {
				this.showCannotAddSiteModal(response,null, autocomplete);
			}
			//}
		},
		setupAutocomplete: function (moniker, parameters, extentSize) {
			view_manager.setupAutoComplete(this, moniker, {
				urlParameters: parameters,
				isComposite: this.assetsOnMapEnabled,
				inputNameAttr: this.assetsOnMapEnabled ? 'combinedSite' : null,
				layerList:this.activeMapLayers,
				selectedCallback: (delegateResponse, selectedItem) => {
					this.autocompleteCallback(delegateResponse, selectedItem, extentSize);
				},
				excludeItemCallback: (item) => {
					return item.entries.exclude === true;
				}
			});
		},
		updateAutocompleteLayerData: function (activeMapLayers) {
			let currentSiteTypes = this.currentSiteTypeArray();//get currently allowed site types based on primary/associated site types
			let currentLayers = activeMapLayers.filter((layer)=>{
				let ret = false;
				currentSiteTypes.forEach((type) => {
					if(layer.siteType == type){
						ret = true;
					} 
				});
				return ret;
			})
			if(this.ui.autocompleteCombinedSiteInput.data){//this function can run before the view renders. That's ok, but we don't want to throw an error. This will re-run once the view is rendered.
				this.ui.autocompleteCombinedSiteInput
					.data('layerList', currentLayers)
					.trigger('autocomplete:updatesettings'); 
				}
		},
	}
});